export const ApiResponseExampleData = {
  uuid: '82027298-e4cf-4c60-8c2a-7129bca41e31',
  publishTime: '2016-06-02T12:00:27.824Z',
  title: `Goldman Lowers iPhone Estimates, Cuts Apple's Price Target By 9 % -Apple Inc. (NASDAQ:AAPL) | Benzinga`,
  description: `Goldman Sachs’ Simona Jankowski mentioned that the estimates for Apple Inc. (NASDAQ: AAPL) had been reduced to reflect lower market growth and lower ...`,
  assetTags: [
    'Apple',
    'AAPL US',
  ],
  searchTags: [
    'Apple',
  ],
  category: 'major_publication',
  url: 'http://www.benzinga.com/analyst-ratings/analyst-col-or/16/06/8060449/goldman-lowers-iphone-estimates-cuts-apples-price-target',
  cityfalconScore: '48',
  source: {
    name: 'www.benzinga.com',
    imageUrl: 'https://cityfalconproduction.blob.core.windows.net/autot-weetmedia/domains/logos/1308/original/PMttsGmx.png?1453405779',
  },
  duplicatesCount: '10',
  paywall: 'false',
  registrationRequired: 'false',
}
